// extracted by mini-css-extract-plugin
export default {"QuoteCta":"XSqQ0KVqd0RsFB8M4qIr","QuoteCta_inner":"FRdml8DFeJ_pRm2SCRuB"};